// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"862ef934","513":"b1c0248a","703":"a26d1939","787":"b2c53d43"}[chunkId] + ".chunk.js";
};